import {revealDependents} from './FieldReveal';

export const handleIntervalToggleChange = target => {
    const container = target.closest('[data-interval-toggle]');
    const detail = container.querySelector('[data-interval-toggle-detail]');
    const disabledValue = container.querySelector('[data-interval-toggle-off]');

    detail.hidden = !target.checked;
    detail.disabled = !target.checked;
    disabledValue.disabled = target.checked;

    revealDependents(target, disabledValue.name, target.checked);
};

export const handleSettingToggleChange = target => {
    revealDependents(target, target.name, target.checked);
};

export const syncTogglesOnRestore = () => {
    document.querySelectorAll('[data-interval-toggle-switch]')
        .forEach(toggle => handleIntervalToggleChange(toggle));

    document.querySelectorAll('[data-setting-toggle-switch]')
        .forEach(toggle => handleSettingToggleChange(toggle));
};
